var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('os-app-bar'),_c('v-main',{staticClass:"background-gradient-image"},[(_vm.appIsReady)?_c('v-container',{attrs:{"fluid":""}},[(_vm.$global.roles.isTrial())?_c('os-trial-banner'):_vm._e(),_c('router-view')],1):_vm._e()],1),_c('os-global-dialogs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }